export const GET_ACTIVITIES_HISTORY = `
query getActivitiesHistory ($input: GetActivitiesHistoryInput!) {
	getActivitiesHistory(input: $input) {
		__typename
		... on FlowActivity {
			id
			flow_id
      		flow_name
      		name
			start_date
			end_date
      		due_date
			assignee
			comment
			previous_task_comment
			previous_task
			previous_task_id
			assigner
			assigner_name
			reason
			end_date_instance
			sequence_order
			documentation {
				nextTask {
					approval
					decline
				}
				description
			}
			description
			status {
				id
				name
			} 
		}
		
	}
}
`;

export const GET_NEXT_ACTIVITY_BY_DOCUMENTATION = `
	query getNextActivityByDocumentation($input: GetNextActivityByDocumentation!) {
  getNextActivityByDocumentation(input: $input) {
    __typename
    ... on WorkflowOperationResponse {
      message
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const GET_ACTIVITIES_HISTORY_BY_INSTANCE = `
query getActivitiesHistoryByInstance ($input: GetActivitiesHistoryByInstanceInput!) {
	getActivitiesHistoryByInstance(input: $input) {
		__typename
		... on FlowActivity {
			id
			flow_id
      		flow_name
      		name
			start_date
			end_date
      		due_date
			assignee
			comment
			previous_task_comment
			previous_task
			previous_task_id
			assigner
			assigner_name
			reason
			sequence_order
			documentation {
				nextTask {
					approval
					decline
				}
				description
			}
			description
			status {
				id
				name
			} 
		}
		
	}
}
`;

export const GET_WORKFLOW_FILES_BY_TASK = `
  query getWorkflowFilesByTask($input: GetWorkflowFilesInput!) {
    getWorkflowFilesByTask(input: $input) {
      files {
        id
        filename
        original_filename
        mime_type
        workflow_instance_id
        task_id
        its
        url
        __typename
      }
      __typename
    }
  }
`;
